import type { GridCellParams } from '@mui/x-data-grid-pro';
import { isEmpty } from 'lodash';

export const noValueClassName = (params: GridCellParams<any, string>) => {
  if (isEmpty(params.value)) return 'no-value';
  return '';
};
